
import React, { useContext, useState } from 'react'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import HighGharLogo from "../assest/HighGharLogo_01.png"
import loginbg2 from "../assest/bgcovermeat.png"
const AdminLogin = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState({
        username: "",
        password: ""
    });
    const navigate = useNavigate();


    const handleOnChange = (e) => {
        const { name, value } = e.target;

        setData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(SummaryApi.verifyAdmin.url, {
                method: SummaryApi.verifyAdmin.method, // Assuming POST method is required by userlogin.php
                headers: {
                    'Authorization': 'Bearer oakyaecom_no_units_916',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: data.username,
                    password: data.password
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to verify username');
            }

            const responseData = await response.json();
            console.log(responseData)
            if (responseData.status) {
                toast.success(responseData.message);
                sessionStorage.setItem('H7Z4L9VD2XK5JW8QRYT6', btoa(responseData.adminid));//"H7Z4L9VD2XK5JW8QRYT6" Random 16-character hashcode
                navigate('/dashboard');

            } else {
                toast.error(responseData.message);
            }
        } catch (error) {
            toast.error('Failed to check username existence');
        }
    };

    console.log("data login", data);

    return (
<section id='login' className="h-screen flex items-center justify-center bg-gradient-to-r from-blue-200 to-teal-200">
    <div className='mx-auto container p-4'>
        <div className='bg-white p-8 w-full max-w-md mx-auto rounded-lg shadow-lg'>
            <div className='w-32 h-32 mx-auto'>
                <img src={HighGharLogo} alt='login icon' />
            </div>

            {/* Login Heading with High Ghar Name */}
            <h1 className='text-4xl font-extrabold text-center mt-4 mb-6 text-gray-800'>
                <span className='text-red-600'>High</span> Ghar
            </h1>

            <h2 className='text-2xl text-center text-gray-600'>Login</h2>

            <form className='pt-6 flex flex-col gap-4' onSubmit={handleSubmit}>
                <div className='grid'>
                    <label className='text-gray-700'>Username:</label>
                    <div className='bg-slate-100 p-2'>
                        <input
                            type='text'
                            placeholder='Enter username'
                            name='username'
                            value={data.username}
                            onChange={handleOnChange}
                            className='w-full h-full outline-none bg-transparent'
                        />
                    </div>
                </div>

                <div>
                    <label className='text-gray-700'>Password:</label>
                    <div className='bg-slate-100 p-2 flex'>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder='Enter password'
                            value={data.password}
                            name='password'
                            onChange={handleOnChange}
                            className='w-full h-full outline-none bg-transparent'
                        />
                        <div className='cursor-pointer text-xl' onClick={() => setShowPassword((prev) => !prev)}>
                            <span>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                    </div>
                </div>

                <button className='bg-red-600 hover:bg-red-700 text-white px-6 py-2 w-full max-w-[150px] rounded-full hover:scale-110 transition-all mx-auto block mt-6'>
                    Login
                </button>
            </form>
        </div>
    </div>
</section>

    
    );
}

export default AdminLogin;
